import * as React from "react";

type Total = {
  total: {
    title: string;
    value: string;
  };
  subtotals?: { title: string; value: string }[];
};

export const Total = React.memo(({ total, subtotals }: Total) => {
  return (
    <div style={{ marginTop: "50px" }}>
      <hr />
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          fontSize: "22px",
          fontWeight: 600,
          color: "#004a97",
        }}
      >
        <div style={{ textAlign: "left" }}>{total?.title}</div>
        <div style={{ textAlign: "right" }}>{total?.value}</div>
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
        }}
      >
        {subtotals && subtotals.length > 0
          ? subtotals.map((subtotal) => {
              return (
                <>
                  <div style={{ textAlign: "left" }}>{subtotal?.title}</div>
                  <div style={{ textAlign: "right" }}>{subtotal?.value}</div>
                </>
              );
            })
          : null}
      </div>
      <hr />
    </div>
  );
});
